import { useEffect, useState } from 'react';
import Spinner from './Spinner';
import Card from './Card';
import { fetchListings } from './api';

export default function FeaturedProds() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch All Inventory (Listings)
    fetchListings()
      .then((data) => {
        // Filter out listings that are marked as sold
        const availableListings = data.filter(
          listing => listing.meta_box._al_listing_listing_state !== 'Sold'
        );
        setPosts(availableListings);
        setLoading(false);
    });
  }, []);

  return (
    <div className="bg-white">
      {loading
      ? <div className='flex justify-center py-48'><Spinner /></div>
      :
      <div className="mx-auto max-w-2xl px-4 py-8 sm:px-6 sm:py-24 lg:max-w-7xl lg:px-8">
        
          
        {posts.length > 0 ? (
          <>
          <h2 className="text-2xl font-semibold leading-7 text-slate-700 mb-8">Featured Vehicles</h2>
          <p className="sr-only">Featured Vehicles</p>
          <div className="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:grid-cols-3 lg:gap-x-8">
              {posts.map((listing) => (
                <Card key={listing.id} listing={listing} />
              ))}
          </div>
          <div className="mt-6 flex items-center gap-x-6">
            <a
              href="/inventory"
              className="rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              View Inventory <span aria-hidden="true">→</span>
            </a>
          </div>
          </>
        ) : (
          <p className="text-center text-gray-500 py-8">No available vehicles to display at this time.</p>
        )}
        
      </div>
      }
    </div>
  );
}
